var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"expert"},[_c('Breadcrumb'),_c('collect',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showFather),expression:"$route.meta.showFather"}],attrs:{"parentmsg":_vm.type}}),_c('router-view')],1),(_vm.footersType == 0)?_c('footers'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }